export const CONFIG_URL = {
    ORGANIZATION_CODE: "organisationCode",
    IS_SUPERADMINISTRATOR: "isProtech",
    IS_CTONLINE_LIMITED: "isLimited",
    USERNAME: "userName",
    LOGINTYPE: "loginType",
    TIMESTAMP: "connexionTimeStamp",
    SIGNATURE: "signature",
}